/** Every dashboard page that talks to /auth/billing/* needs the same origin resolution — one place for it. */
function getBillingOrigin(): string {
    return import.meta.env.VITE_AUTH_URL || window.location.origin;
}

function billingUrl(path: string): string {
    return new URL(path, getBillingOrigin()).toString();
}

export function getUsageUrl(): string {
    return billingUrl("/auth/billing/usage");
}

import type { UpgradeSurface } from "../../../utils/conversion-shared";

export function getCheckoutUrl(surface?: UpgradeSurface): string {
    const url = new URL("/auth/billing/checkout", getBillingOrigin());
    url.searchParams.set("redirect", "true");
    if (surface) {
        url.searchParams.set("surface", surface);
    }
    return url.toString();
}

export function getSubscriptionUrl(): string {
    return billingUrl("/auth/billing/subscription");
}

export function getBillingPortalUrl(): string {
    return billingUrl("/auth/billing/portal");
}

/** Read-only public endpoint; never includes the signed-in user's session. */
export function getPriceEstimateUrl(country: string, postalCode?: string): string {
    const url = new URL("/auth/billing/price-estimate", getBillingOrigin());
    url.searchParams.set("country", country);
    if (postalCode) {
        url.searchParams.set("postal_code", postalCode);
    }
    return url.toString();
}

/** Country hint from the server's CDN geo header; not a verified billing address. */
export function getBillingCountryHintUrl(): string {
    return billingUrl("/auth/billing/country-hint");
}
